import { Link } from "@tanstack/react-router";
import { MessageCircleHeart } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Το κοινό κουμπί-σύντομος σύνδεσμος για τη σελίδα /pandaki.
 * - "pill": μικρό στρογγυλό κουμπί για κεφαλίδες ενοτήτων (π.χ. «Κορυφαία σε
 *   Πωλήσεις»).
 * - "strip": πάνω κορδέλα του header, αριστερά από τα «Κορυφαία σε Πωλήσεις».
 *   Εκεί το πεδίο των συνδέσμων έχει overflow-hidden, άρα το κουμπί δεν πρέπει
 *   να μεγαλώνει ή να ανεβαίνει στο hover — αλλιώς κόβεται από πάνω.
 * - "sheet": φαρδύ κουμπί μέσα στη λίστα κατηγοριών (μενού).
 * Χρησιμοποιεί αποκλειστικά τα design tokens του eshop ώστε να φοράει και το
 * σκούρο θέμα.
 */
const VARIANTS = {
  pill:
    "mp-bouncy shrink-0 rounded-full bg-gradient-to-r from-primary to-primary-strong px-3 py-1.5 text-xs text-primary-foreground ring-primary-foreground/20 hover:scale-105",
  strip:
    "shrink-0 rounded-full bg-primary-foreground/12 px-2 py-1 text-primary-foreground ring-primary-foreground/25 hover:bg-primary-foreground/22",
  sheet:
    "mp-bouncy w-full rounded-2xl bg-gradient-to-r from-primary to-primary-strong px-3 py-2.5 text-sm text-primary-foreground ring-primary-foreground/20 hover:scale-105",
} as const;

export function PandakiButton({
  variant = "pill",
  className,
  onNavigate,
}: {
  variant?: keyof typeof VARIANTS;
  className?: string;
  onNavigate?: () => void;
}) {
  return (
    <Link
      to="/pandaki"
      onClick={onNavigate}
      aria-label="Άνοιξε το Pandaki — ψώνισε συζητώντας"
      className={cn(
        "inline-flex items-center gap-1.5 font-bold shadow-sm ring-1 transition-all",
        VARIANTS[variant],
        className,
      )}
    >
      <MessageCircleHeart className={variant === "strip" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      <span className={variant === "strip" ? "hidden lg:inline" : ""}>Pandaki</span>
      {variant !== "strip" && (
        <span aria-hidden className="text-base leading-none">
          🐼
        </span>
      )}
    </Link>
  );
}
